<template>
  <div class="services">
    <page-head-static-component
      :bgImg="require('@/assets/img/head-static_bg.png')"
      textColor="#FFFFFF"
      :ttl="'Услуги'"
    ></page-head-static-component>

    <block-container-component bgC="#f3f3f3">
      <template slot="content">
        <tabs-component></tabs-component>
      </template>
    </block-container-component>

    <cta-form-component>
      <template slot="button">
        <button-component class="bordered-btn">Оставить заявку</button-component>
      </template>
    </cta-form-component>

    <text-container-component :servtext="pageData !== null ? pageData.servicescat : {}"></text-container-component>

  </div>
</template>


<script>
// @ is an alias to /src

const axios = require("axios");
export default {
  data() {
    return {
      pageData: null,
      pageCases: null
    };
  },
  beforeMount() {
    axios
      .get(
        `${this.$root.routLink}${this.$route.path}?ajax&act=services_page_data`,
        { responseType: "json" }
      )
      .then(({ data }) => {
        this.pageData = JSON.parse(data.addons);
      });
    axios
      .get(
        `${this.$root.routLink}${this.$route.path}?ajax&act=services_page_objects`,
        { responseType: "json" }
      )
      .then(({ data }) => {
        this.pageCases = JSON.parse(data.addons);
      });
  }
};
</script>

<style lang="scss" scoped>
.home {
  background-color: #ffffff;
}
</style>
